import * as React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import * as moment from "moment";
import { Col, Row, Glyphicon } from "react-bootstrap";
import TextoAyuda from "../../config_general/componentes/TextoAyuda";
import { Form } from "react-final-form";
import { REQUEST } from "../../../../config/ajax-wrapper";
import MensajeConAccion from "../../../general/componentes/MensajeConAccion";
import { DotLoader } from "react-spinners";
import { consultarServiciosReciboSat } from "../../../general/modulos/maestrosActions";
import ModalXLSDatosGlosas from "../../inconsistencias/componentes/ModalXLSDatosGlosas";

import {
    documentoEmpleador,
    tipoDocumentoEmpleador,
    tipoTransaccion,
    fechaInicialConsulta,
    fechaFinalConsulta,
    estadosProceso,
    consecutivoSolicitud
} from "../../config_general/modelo/TextosAyuda";
import DatePickerSura from "../../../general/componentes/DatePicker";
import TextoInputSelector from "../../../general/componentes/TextoInputSelector";
import TipoIdentificacion from "../../../general/componentes/TipoIdentificacion";
import NumericInput from "../../../general/componentes/NumericInput";
import { listarServicios, listaEstadosReciboSAT, FiltroConsultaReciboResumen } from "../../config_general_recibo/modelo/NovedadesRecibidas";
import { EstadoReciboSAT } from "../../config_general_recibo/modelo/EstadoReciboSAT";
import { CODIGOS_CONSULTA } from "../../config_general_recibo/modelo/CodigosConsulta";
import { consultarNovedadesResumen, consultarNovedadesResumenXLS, limpiarMensajesEstado } from "../modulos/reciboNovedadesResumenActions";
import DivisorConTexto from "../../config_general/componentes/DivisorConTexto";
import TablaConsultaResumen from "./TablaConsultaResumen";
import TextoInput from "../../../general/componentes/TextoInput";

class FiltroConsultaResumen extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.generarXLS = this.generarXLS.bind(this);

        this.state = {
            showModalXLS: false,
            maxRegistrosXLS: 10000
        };
    }

    componentWillMount() {
        if (!this.props.serviciosReciboSat || this.props.serviciosReciboSat.length === 0) {
            this.props.dispatch(consultarServiciosReciboSat());
        }
    }

    componentWillUnmount() {
        this.props.dispatch(limpiarMensajesEstado());
    }

    render() {
        const { totalRegistros } = this.props;
        return (
            <div>
                <Row>
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Consulta Resumen Novedades Recibidas SAT</h1>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Filtros consulta</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label>Fecha Inicial de Operación</label>
                                                <TextoAyuda texto={fechaInicialConsulta} />
                                                <DatePickerSura name={"fechaInicial"} fechaMaxima={moment()} />
                                            </Col>
                                            <Col sm={3}>
                                                <label>Fecha Final de Operación</label>
                                                <TextoAyuda texto={fechaFinalConsulta} />
                                                <DatePickerSura name={"fechaFinal"} fechaMaxima={moment()} />
                                            </Col>
                                        </Row>
                                        <br />
                                        <DivisorConTexto texto="opcional" />
                                        <br />
                                        <Row className={"form-group"}>
                                            <Col sm={5}>
                                                <label htmlFor="consecutivoSolicitud">Consecutivo SAT</label>
                                                <TextoAyuda texto={consecutivoSolicitud} />
                                                <TextoInput name="consecutivoSolicitud" placeholder="Ingrese consecutivo transaccion" maxLength={50} />
                                            </Col>
                                        </Row>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label htmlFor="tipoDocumento">Tipo Documento Empleador</label>
                                                <TextoAyuda texto={tipoDocumentoEmpleador} />
                                                <TipoIdentificacion name="tipoDocumento" />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="documento">Documento Empleador</label>
                                                <TextoAyuda texto={documentoEmpleador} />
                                                <NumericInput name="documento" placeholder="Ingrese un documento" />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="tipoTransaccion">Tipo de Transacción</label>
                                                <TextoAyuda texto={tipoTransaccion} />
                                                <TextoInputSelector name="tipoTransaccion" maestro={listarServicios(this.props.serviciosReciboSat)} />
                                                {errors.tipoTransaccion &&
                                                    <div style={{ marginTop: '5px' }}>
                                                        <span className={"text-danger"}>{errors.tipoTransaccion}</span>
                                                    </div>
                                                }
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={9}>
                                                <label>Estados</label>
                                                <TextoAyuda texto={estadosProceso} />
                                                <TextoInputSelector name="estados" selectorMultiple maestro={listaEstadosReciboSAT(EstadoReciboSAT)} />
                                                {errors.estados &&
                                                    <div style={{ marginTop: '5px' }}>
                                                        <span className={"text-danger"}>{errors.estados}</span>
                                                    </div>
                                                }
                                            </Col>
                                        </Row>
                                        <div style={{ marginTop: `50px` }}>
                                            <Row className={"form-group"}>
                                                <Col sm={5}>
                                                    {
                                                        (totalRegistros > 0) &&
                                                        <a className="btns btn-success" onClick={this.obtenerXLS}>
                                                            <b>Exportar XLSX</b> &nbsp;<Glyphicon className={"download-alt"} glyph={"download-alt"} />
                                                        </a>
                                                    }
                                                    {this.state.showModalXLS && this.mostrarModalXLS()}
                                                </Col>
                                                <Col smOffset={3} sm={1}>
                                                    <button type="button" className="btns btns-link" onClick={form.reset}
                                                        disabled={submitting || pristine}>
                                                        Limpiar
                                                    </button>
                                                </Col>
                                                <Col sm={2}>
                                                    <button type="submit" className="btns btns-primary" disabled={submitting || invalid}>
                                                        <b>Consultar</b> &nbsp;<Glyphicon className={"search"} glyph={"search"} />
                                                    </button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                </Row>
                <Row>
                    {this.renderEstadoDescargaXLS()}
                    {this.renderTabla()}
                </Row>
            </div>
        );
    }

    obtenerXLS = () => {
        const { totalRegistros } = this.props;
        if (totalRegistros < this.state.maxRegistrosXLS) {
            this.generarXLS(0);
        } else {
            this.setState({ showModalXLS: true });
        }
    };

    generarXLS(reporte: number) {
        const filtro: FiltroConsultaReciboResumen = {
            dniEmpleador: this.state.dniEmpleador,
            fechaInicial: this.state.fechaInicial,
            fechaFinal: this.state.fechaFinal,
            servicio: this.state.servicio,
            estados: this.state.estados,
            consecutivoSolicitud: this.state.consecutivoSolicitud,
            codigoConsulta: CODIGOS_CONSULTA.CONSULTA_NOVEDADES_RESUMEN,
            dniUsuarioOperacion: this.props.dniUsuarioGestionLogin,
            tamanoPagina: this.state.maxRegistrosXLS,
            paginaActual: reporte
        };
        this.props.dispatch(consultarNovedadesResumenXLS(filtro));
    }

    mostrarModalXLS() {
        const { totalRegistros, tamanoPagina } = this.props;
        const reportesXLS = Math.ceil(totalRegistros / this.state.maxRegistrosXLS);
        const totalPaginas = Math.ceil(totalRegistros / tamanoPagina);
        return (
            <ModalXLSDatosGlosas
                totalGlosasConsulta={totalRegistros}
                reportesXLS={reportesXLS}
                totalPaginas={totalPaginas}
                showModalXLS={this.state.showModalXLS}
                closeModalXLS={() => this.handleCloseModalXLS()}
                generarXLS={this.generarXLS}
                maxRegistrosXLS={this.state.maxRegistrosXLS}
                tamanoPaginaFiltro={tamanoPagina}
            />
        );
    }

    handleCloseModalXLS() {
        this.setState({ showModalXLS: false });
    }

    renderTabla() {
        const { estadoConsultaResumen, resumenNovedades, tamanoPagina, paginaActual, paginas, totalRegistros } = this.props;
        switch (estadoConsultaResumen) {
            case REQUEST.ERROR:
                return <MensajeConAccion type={"danger"} mensaje={"Se ha presentado un error, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return <DotLoader size={25} />;
            case REQUEST.SUCCESS:
                if (!resumenNovedades || !resumenNovedades.length)
                    return (
                        <span>
                            <MensajeConAccion type={"info"} mensaje={"No se han encontrado mensajes"} />
                        </span>
                    );
                else
                    return (
                        <span>
                            <TablaConsultaResumen
                                registros={resumenNovedades}
                                filtro={this.filtros()}
                                paginas={paginas}
                                tamanoPagina={tamanoPagina}
                                paginaActual={paginaActual}
                                totalRegistros={totalRegistros}
                                consultaPaginada={this.consultaPaginada}
                            />
                        </span>);
            default:
                return false;
        }
    }

    renderEstadoDescargaXLS() {
        const { estadoDescargaXLS } = this.props;
        switch (estadoDescargaXLS) {
            case REQUEST.ERROR:
                return <MensajeConAccion type={"danger"} mensaje={"Se ha presentado un error al generar el reporte, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return (
                    <div>
                        <DotLoader size={25} />
                        <br />
                    </div>);
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <MensajeConAccion type={"success"} mensaje={"Se genero el reporte con exito"} />
                    </span>
                );
            default:
                return false;
        }
    }

    filtros(): FiltroConsultaReciboResumen {
        return {
            dniEmpleador: this.state.dniEmpleador,
            fechaInicial: this.state.fechaInicial,
            fechaFinal: this.state.fechaFinal,
            servicio: this.state.servicio,
            estados: this.state.estados,
            consecutivoSolicitud: this.state.consecutivoSolicitud,
            codigoConsulta: CODIGOS_CONSULTA.CONSULTA_NOVEDADES_RESUMEN,
            dniUsuarioOperacion: this.props.dniUsuarioGestionLogin
        };
    }

    consultaPaginada = (filtro: FiltroConsultaReciboResumen) => {
        this.props.dispatch(consultarNovedadesResumen(filtro));
    };

    onSubmit = (values: any) => {
        this.props.dispatch(consultarNovedadesResumen(this.obtenerValores(values)));
    };

    obtenerValores = (values: any) => {
        const dni = (values.tipoDocumento && values.documento) ? (values.tipoDocumento + values.documento) : undefined;
        const fechaInicial = values.fechaInicial ? values.fechaInicial.format("YYYY-MM-DD").valueOf() : "";
        const fechaFinal = values.fechaFinal ? values.fechaFinal.format("YYYY-MM-DD").valueOf() : "";
        const tipoTransaccion = values.tipoTransaccion ? Number(values.tipoTransaccion.value) : undefined;
        const estados = (values.estados) ? values.estados.map(estado => estado.value) : undefined;
        const consecutivoSolicitud = values.consecutivoSolicitud ? values.consecutivoSolicitud : undefined;


        const filtro: FiltroConsultaReciboResumen = {
            dniEmpleador: dni,
            fechaInicial: fechaInicial,
            fechaFinal: fechaFinal,
            servicio: tipoTransaccion,
            estados: estados,
            consecutivoSolicitud: consecutivoSolicitud,
            codigoConsulta: CODIGOS_CONSULTA.CONSULTA_NOVEDADES_RESUMEN,
            tamanoPagina: this.props.tamanoPagina,
            paginaActual: 0,
            dniUsuarioOperacion: this.props.dniUsuarioGestionLogin
        };

        this.setState({
            dniEmpleador: dni,
            fechaInicial: fechaInicial,
            fechaFinal: fechaFinal,
            servicio: tipoTransaccion,
            estados: estados,
            consecutivoSolicitud: consecutivoSolicitud,
            filtro: filtro
        });

        return filtro;
    };

    validate = (values: any) => {
        const errors = {
            fechaInicial: undefined,
            fechaFinal: undefined,
            documento: undefined,
            tipoDocumento: undefined,
            tipoTransaccion: undefined
        };

        if (!values.fechaInicial)
            errors.fechaInicial = "Por favor seleccione una fecha";

        if (values.fechaInicial && !values.fechaFinal)
            errors.fechaFinal = "Por favor seleccione una fecha";

        if (values.fechaInicial && values.fechaFinal && values.fechaInicial.isAfter(values.fechaFinal)) {
            errors.fechaFinal = "La fecha final no puede ser anterior a la fecha inicial";
        }

        if (values.tipoDocumento && !values.documento)
            errors.documento = "Se debe ingresar el numero de documento";

        if (values.documento && !values.tipoDocumento)
            errors.tipoDocumento = "Se debe seleccionar el tipo de documento";

        if (values.documento && values.tipoDocumento && !values.tipoTransaccion)
            errors.tipoTransaccion = "Se debe seleccionar el servicio";

        return errors;
    };

}

export default connect((store: any) => {
    return {
        dniUsuarioGestionLogin: R.pathOr(undefined, ["inicio", "dniLogin"])(store),
        resumenNovedades: R.pathOr([], ["recibo_resumen_novedades", "resumenNovedades"])(store),
        paginas: R.pathOr(0, ["recibo_resumen_novedades", "paginas"])(store),
        totalRegistros: R.pathOr(0, ["recibo_resumen_novedades", "totalRegistros"])(store),
        paginaActual: R.pathOr(0, ["recibo_resumen_novedades", "paginaActual"])(store),
        tamanoPagina: R.pathOr(10, ["recibo_resumen_novedades", "tamanoPagina"])(store),
        estadoDescargaXLS: R.pathOr(undefined, ["recibo_resumen_novedades", "estadoDescargaXLS"])(store),
        estadoConsultaResumen: R.pathOr(undefined, ["recibo_resumen_novedades", "estadoConsultaResumen"])(store),
        serviciosReciboSat: R.pathOr([], ["maestros", "serviciosReciboSat"])(store)
    };
})(FiltroConsultaResumen);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/recibo_novedades_resumen/componentes/FiltroConsultaResumen.tsx